import { success, error } from 'redux-saga-requests';
import {
  GET_SUPPLIERS,
  CREATE_SUPPLIER,
  REMOVE_SUPPLIER,
  UPDATE_SUPPLIER,
} from './types';

const initialState = {
  suppliers: [],
  loading: false,
  error: null,
};

const getSupplierId = (supplier) => supplier?.id ?? supplier?.supplier_id;
const getSuppliersList = (data) => data?.suppliers ?? data ?? [];
const getSupplierPayload = (data) => data?.supplier ?? data;
const idsMatch = (left, right) => String(left) === String(right);

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPLIERS:
    case CREATE_SUPPLIER:
    case REMOVE_SUPPLIER:
    case UPDATE_SUPPLIER:
      return { ...state, error: null, loading: true };

    case success(GET_SUPPLIERS): {
      const suppliers = getSuppliersList(action.data);
      return {
        ...state,
        suppliers: Array.isArray(suppliers) ? suppliers : [],
        loading: false,
      };
    }

    case success(CREATE_SUPPLIER): {
      const supplier = getSupplierPayload(action.data);
      return {
        ...state,
        suppliers: supplier && typeof supplier === 'object'
          ? [...state.suppliers, supplier]
          : state.suppliers,
        loading: false,
      };
    }

    case success(REMOVE_SUPPLIER): {
      const supplierId = action?.meta?.requestAction?.supplierId;
      return {
        ...state,
        suppliers: state.suppliers.filter((supplier) => !idsMatch(getSupplierId(supplier), supplierId)),
        loading: false,
      };
    }

    case success(UPDATE_SUPPLIER): {
      const supplier = getSupplierPayload(action.data);
      const supplierId = action?.meta?.requestAction?.supplierId ?? getSupplierId(supplier);
      return {
        ...state,
        suppliers: state.suppliers.map((item) => (
          idsMatch(getSupplierId(item), supplierId)
            ? { ...item, ...supplier }
            : item
        )),
        loading: false,
      };
    }

    case error(GET_SUPPLIERS):
    case error(CREATE_SUPPLIER):
    case error(REMOVE_SUPPLIER):
    case error(UPDATE_SUPPLIER):
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
